var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"PEOPLE MANAGEMENT","title":"Staff Management","description":"Manage staff profiles, performance reviews and leave requests.","count-label":"staff tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }